import { PaidEarlyAccessSegment } from 'shared/store/remoteConfig/types';

/**
 * Checks if paid early access parameter should be sent to APIs
 * @param paidEarlyAccessSegment - Remote config containing enabled flag and target segment value
 * @param paidEarlyAccess - User's current segment from auth
 * @returns boolean - true if user qualifies for paid early access
 */
export const shouldSendPaidEarlyAccess = (
  paidEarlyAccessSegment?: PaidEarlyAccessSegment,
  paidEarlyAccess?: string | null
): boolean => {
  const { enabled = false, paidEarlyAccess: configSegment } =
    paidEarlyAccessSegment || {};

  if (!enabled) {
    return false;
  }

  const configValue = configSegment?.value;
  return !!(paidEarlyAccess && configValue && paidEarlyAccess === configValue);
};
